import React, { Component } from "react"
import { Form } from "app/forms/form"
import * as Elements from "app/forms/elements"

import thumbnail from "app/forms/images/templates/pine.jpg"

class Pine extends Component {
  static displayName = "Pine"
  static style = "form"
  static formats = ["inline", "modal", "slide in"]
  static thumbnail = thumbnail
  static fields = [
    {
      name: "first_name",
      label: "Your first name"
    },
    {
      name: "email_address",
      label: "Your email address"
    }
  ]

  render() {
    const { elements, styles, ...props } = this.props

    return (
      <Form
        {...props}
        style={styles.forElement("form", {
          backgroundColor: "#ffffff",
          borderRadius: 4
        })}
      >
        <div data-style="full">
          <div
            style={styles.forElement("content")}
            data-element="column"
            className="formkit-column"
          >
            <div
              style={styles.forElement("background")}
              className="formkit-background"
            />
            <Elements.Header
              tag="h2"
              name="header"
              defaults={{ content: "Join the Newsletter" }}
            />
            <Elements.Content
              name="subheader"
              defaults={{
                content: "Subscribe to get our latest content by email."
              }}
            />
            <Elements.Image name="image" />
          </div>
          <div data-element="column" className="formkit-column">
            <Elements.Errors />

            <Elements.CustomFields>
              <Elements.AddFieldButton />
              <Elements.Button
                name="submit"
                group="button"
                defaults={{ content: "Subscribe" }}
              />
            </Elements.CustomFields>

            <Elements.Content
              name="guarantee"
              defaults={{
                content: "We respect your privacy. Unsubscribe at any time."
              }}
            />

            <Elements.BuiltWith background="form" />
          </div>
        </div>
      </Form>
    )
  }
}

Pine.displayName = "Pine"

export default Pine
